(function(){
    angular.module('tmx-app').factory('PjpService', ['$http','tmxResource','$mdMedia','$q','tmxUtility','LocationService',
        // eslint-disable-next-line angular/di-unused
        function($http,tmxResource,$mdMedia,$q,tmxUtility,LocationService){
         
            var Pjps = tmxResource("PJPMaster");
            function httpConfig(method, url, data) {
                this.url = url;
                this.method = method;
                this.data = data;
            }
            LocationService.lov().then(function(result){
                Pjps.gridColumn[1].data = result.data;
                Pjps.recievedLov=true;
                Pjps.locations = result.data;
            });

            Pjps.status = [
                { 
                    HiddenValue: "active",
                    VisibleValue: "Active"
                },
                { 
                    HiddenValue: "pending",
                    VisibleValue: "Pending"
                },
            // { 
            //     HiddenValue: "inactive",
            //     VisibleValue: "Inactive"
            // }
            ];
            Pjps.getById = function (id, successcb, errorcb) {

                return Pjps.thenFactoryMethod(new httpConfig('get', Pjps.url + '/' + id), successcb, errorcb);
            };

            Pjps.gridColumn = [

                {
                    field: "PJPName",
                    title: "PJP Name",
                    type: "string",
                    search: true,
                    // width: $mdMedia('gt-sm')?'30%':'150px',
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : PjpCtrl.isFiltered('PJPName')}\" >Pjp Name <i class='fa fa-filter'ng-if='PjpCtrl.isFiltered(\"PJPName\")' ></i></span>"
                },
            /* {
             field: "PjpDescription",
             title: "Pjp Description",
             type: "string",
             search: true,
             headerTemplate:"<span  ng-class=\"{ 'filter-active' : PjpCtrl.isFiltered('PjpDescription')}\" >Pjp Description<i class='fa fa-filter' ng-if='PjpCtrl.isFiltered(\"PjpDescription\")' ></i></span>"
             },*/
                {
                    field: "LocationId",
                    title: "PJP Location",
                    type: "select",
                    data: Pjps.locations,
                    isNumber: true,
                    // width: $mdMedia('gt-sm')?'30%':'150px',
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : PjpCtrl.isFiltered('LocationId')}\" >Pjp Location <i class='fa fa-filter' ng-if='PjpCtrl.isFiltered(\"LocationId\")' ></i></span>"
                },
                {
                    field:"PJPClusterUser",
                    title:"User",
                    type: "string",
                    search: true,
                    hidden:true,
                    // width: $mdMedia('gt-sm')?'15%':'150px',
                    headerTemplate:"<span ng-class=\"{ 'filter-active' : PjpCtrl.isFiltered('PjpClusterUser')}\">Pjp User<i class='fa fa-filter' ng-if='PjpCtrl.isFiltered(\"PjpClusterUser\")' ></i></span>"
                },
                {
                    field: "EffectiveStartDate",
                    title: "PJP Date",
                    type: "date",
                    search: true,
                    // width: $mdMedia('gt-sm')?'30%':'150px',
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : PjpCtrl.isFiltered('EffectiveStartDate')}\" >Pjp Date<i class='fa fa-filter' ng-if='PjpCtrl.isFiltered(\"EffectiveStartDate\")' ></i></span>"
                },
                {
                    field: "Status",
                    title: "Status",
                    type: "select",
                    data: Pjps.status,
                    search: true,
                    hidden:true,
                    // width: $mdMedia('gt-sm')?'15%':'150px',
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : PjpCtrl.isFiltered('Status')}\" >Status <i class='fa fa-filter' ng-if='PjpCtrl.isFiltered(\"Status\")' ></i></span>"
                }

            ];

            Pjps.columns = angular.copy(Pjps.gridColumn);
            Pjps.columns.push(
                {command :[

                ]}
            );
            return Pjps;

        }]);

})();